import { Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { NgClass } from '@angular/common';
import { MatFormField } from '@angular/material/form-field';

@Component({
    selector: 'unite-rented-to-field',
    templateUrl: './rented-to-field.component.html',
    styleUrls: ['./rented-to-field.component.scss'],
    imports: [MatFormField, NgClass, MatSelect, ReactiveFormsModule, MatOption, TranslateModule]
})
export class RentedToFieldComponent {

  control = input<FormControl>();
  classField = input('');
  rentalType = input('');

  editIcon = input(false);
  checkIcon = input(true);


  onEnter(event: KeyboardEvent) {
    (<HTMLInputElement>event.target).blur();
  }
}
